(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("ncTrimDesigner", [], factory);
	else if(typeof exports === 'object')
		exports["ncTrimDesigner"] = factory();
	else
		root["ncTrimDesigner"] = factory();
})(self, function() {
return 